import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SettingsService } from '../../infrastructure/services/settings.service';
import { LoaderService } from '../../infrastructure/services/loader.service';
import { AlertService } from '../../infrastructure/services/alert.service';
import { JsonEditorOptions, JsonEditorComponent } from 'angular4-jsoneditor/jsoneditor/jsoneditor.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  templateUrl: 'userPolicies.entidad.component.html'
})
export class UserPoliciesEntidadComponent implements OnInit {
  tipo: string;

  codSistema: string;
  codNegocio: string;
  codProducto: string;
  setting: any;
  parsedValue: any;

  editorOptions: JsonEditorOptions;

  @ViewChild(JsonEditorComponent) jsonEditor: JsonEditorComponent;

  constructor(private aRoute: ActivatedRoute,
              private modalService: NgbModal,
              private settingsService: SettingsService,
              private alertService: AlertService,
              public loader: LoaderService) {
    // JsonEditor options
    this.editorOptions = new JsonEditorOptions();
    this.editorOptions.modes = ['code', 'text', 'tree', 'view'];
  }

  ngOnInit() {
    this.aRoute.params.subscribe(params => {
      this.codSistema = params['codsistema'];
      this.codNegocio = params['codnegocio'];
      this.codProducto = params['codproducto'];
      this.tipo = params['tipo'];

      if(
      this.codSistema === undefined &&
      this.codNegocio === undefined
      ){
        this.codSistema = 'null';
        this.codNegocio = 'null';
      }

      this.settingsService
        .getByLevel(this.tipo, this.codSistema, this.codNegocio, this.codProducto)
          .then(setting => this.init(setting));
    });
  }

  init(setting) {
    this.setting = setting;

    if (this.setting && this.setting.valor) {
      this.parsedValue = JSON.parse(this.setting.valor);
    }
  }

  guardar() {
    this.buildForSave();

    this.settingsService.crearOEditar(this.setting, this.codSistema, this.codNegocio, this.codProducto)
      .then(res => {
        this.init(res);
        this.alertService.showSuccessMessage('GUARDADO_CORRECTAMENTE');
      });
  }

  open(content) {
    this.modalService.open(content)
      .result.then((result) => this.resetearPorDefault(), (reason) => { /* Do nothing */ });
  }

  resetearPorDefault() {
    this.settingsService.remove(this.tipo, this.codSistema, this.codNegocio, this.codProducto)
      .then(res => {
        this.init(res);
        this.alertService.showSuccessMessage('RESETEADO_CORRECTAMENTE');
      });
  }

  buildForSave() {
    // Obtenemos el json del json-editor
    const values = this.jsonEditor.getText();

    // Seteamos el json
    this.setting.valor = values;
  };
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/settingsEntidad/userPolicies.entidad.component.ts